import { jsx as _jsx } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import AccountEditCard from './components';
import useIsMobile from '../components/useIsMobile';
const AccountEdit = () => {
    const isMoble = useIsMobile();
    return (_jsx(Stack, Object.assign({ direction: isMoble ? 'column' : 'row' }, { children: _jsx(AccountEditCard, {}) })));
};
export default AccountEdit;
